import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../shared/grid"
import BackgroundImage from "gatsby-background-image"
import {
  HeroText,
  SubheadingList,
  ButtonContainer,
  ActionButton,
  StatListContainer,
  StatListItem,
  StatListNumber,
  StatListPlus,
  OverlayUpper,
  OverlayLower,
} from "./hero.style"

const Hero = () => {
  const heroBackground = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "0_HOMEPAGE/homepage_hero.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <BackgroundImage
      fluid={heroBackground.file.childImageSharp.fluid}
      loading="eager"
      critical
      fadeIn={false}
    >
      <Grid overlayStyle={OverlayUpper}>
        <HeroText>Powering mapping experiences for world-class venues</HeroText>
        <SubheadingList>
          <li>
            <span>Digitize Maps</span>
          </li>
          <li>
            <span>Build Applications</span>
          </li>
          <li>
            <span>Edit in Real-time</span>
          </li>
        </SubheadingList>
        <ButtonContainer>
          <ActionButton to="contact-form" smooth duration={1000}>
            Book a Free Demo
          </ActionButton>
        </ButtonContainer>
      </Grid>
      <Grid overlayStyle={OverlayLower}>
        <StatListContainer>
          <StatListItem>
            <StatListNumber>
              1,100<StatListPlus>+</StatListPlus>
            </StatListNumber>
            Live Venues
          </StatListItem>
          <StatListItem>
            <StatListNumber>
              755M<StatListPlus>+</StatListPlus>
            </StatListNumber>
            Sq. Ft. Mapped
          </StatListItem>
          <StatListItem>
            <StatListNumber>
              40<StatListPlus>+</StatListPlus>
            </StatListNumber>
            Countries
          </StatListItem>
        </StatListContainer>
      </Grid>
    </BackgroundImage>
  )
}

export default Hero
